import { render, staticRenderFns } from "./SupportAndContact.vue?vue&type=template&id=6cab7c52&"
import script from "./SupportAndContact.vue?vue&type=script&lang=js&"
export * from "./SupportAndContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports